/* ============================================================
   LP共通スクリプト（LP① 会員登録 ／ LP② 中古買取）

   方針
     - JSが動かなくても内容が全部読める（アコーディオンはCSSのみで動く
       <details>/<summary> を使っているため、そもそもJS依存ではない）
     - 機能ごとにIIFEで分け、どれか1つが壊れても他に影響しない
   ============================================================ */

/* ---- ① ヘッダーの背景切替 ----
   ページ最上部では透明、少しでもスクロールしたら背景色を入れる */
(function () {
  "use strict";
  var header = document.getElementById("lp-header");
  if (!header) return;

  var scrolled = false;
  function onScroll() {
    var now = (window.pageYOffset || document.documentElement.scrollTop) > 4;
    if (now === scrolled) return; /* 変化した時だけ触る */
    scrolled = now;
    header.classList.toggle("is-scrolled", now);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
})();

/* ---- ② ハンバーガー開閉（SP・LP①のみ要素が存在） ---- */
(function () {
  "use strict";
  var toggle = document.getElementById("lp-navtoggle");
  var nav = document.getElementById("lp-navoverlay");
  if (!toggle || !nav) return;

  function setState(open) {
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    toggle.setAttribute("aria-label", open ? "メニューを閉じる" : "メニューを開く");
    nav.classList.toggle("is-open", open);
    document.body.classList.toggle("lp-is-navopen", open);
  }

  toggle.addEventListener("click", function () {
    setState(toggle.getAttribute("aria-expanded") !== "true");
  });

  nav.addEventListener("click", function (e) {
    if (e.target.closest("a")) setState(false);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
      setState(false);
      toggle.focus();
    }
  });

  /* 1024px はヘッダーCSSのブレークポイント（max-width:1023px）と対。
     片方だけ変えると閉じられないオーバーレイが残るので必ず両方直すこと */
  var mq = window.matchMedia("(min-width: 1024px)");
  function onChange(e) {
    if (e.matches) setState(false);
  }
  if (mq.addEventListener) mq.addEventListener("change", onChange);
  else if (mq.addListener) mq.addListener(onChange);
})();

/* ---- ③ SP追従CTAバー ----
   スクロール200px以降で表示。FV・メインCTA帯（LP①）／ダブルCTA（LP②）が
   画面内にある間は隠す。data-sticky-watch を付けたセクションを監視する */
(function () {
  "use strict";
  var bar = document.getElementById("lp-stickycta");
  if (!bar) return;

  var targets = Array.prototype.slice.call(
    document.querySelectorAll("[data-sticky-watch]")
  );

  /* IntersectionObserver は使わない。
     ①「entries には変化した要素しか入らない」ため全体判定を書き間違えやすい
     ② 非表示のペインや瞬間移動するスクロールでは通知が届かず、検証もできない
     位置を毎回その場で測る方式なら、いつ呼んでも同じ答えが出る。
     対象は2〜3個なので getBoundingClientRect のコストも問題にならない。 */
  function update() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var h = window.innerHeight;

    var watchedVisible = targets.some(function (el) {
      var r = el.getBoundingClientRect();
      return r.top < h && r.bottom > 0;
    });

    bar.classList.toggle("is-hidden", y <= 200 || watchedVisible);
  }

  /* スクロール中に毎回測ると重いので間引く。

     間引きに requestAnimationFrame を使わない。
     rAFは環境によって動かないことがある（検証環境で発火しない例を確認している）ため、
     そうなると update() が初回の1度しか走らない。
     初回は y=0 なので **バーが隠れたまま二度と出てこない**＝CTAが永久に消える。
     CV導線が丸ごと失われる壊れ方なので、必ず動く setTimeout で間引く。 */
  var timer = null;
  window.addEventListener(
    "scroll",
    function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        update();
      }, 100);
    },
    { passive: true }
  );

  window.addEventListener("resize", update, { passive: true });
  update();
})();

/* FAQの「もっと見る」は廃止した。6問すべてを最初から表示している。
   畳む処理を入れていたIIFEはここにあったが、対象の要素ごと削除済み。 */

/* ---- ⑤ お客様の声カルーセル（LP②・SP専用） ----
   コーポレートサイトの fsj-carousel.js と同じ scrollLeft 方式。
   ただし自動送りはしない。手動スワイプ＋ドットのみ */
(function () {
  "use strict";
  var root = document.querySelector(".lp2-voice__track");
  if (!root) return;

  var items = Array.prototype.slice.call(root.children);
  var dotsWrap = document.querySelector(".lp2-voice__dots");
  if (dotsWrap) {
    items.forEach(function (_, i) {
      var d = document.createElement("button");
      d.type = "button";
      d.className = "lp2-voice__dot";
      d.setAttribute("aria-label", (i + 1) + "件目の声を表示");
      if (i === 0) d.classList.add("is-active");
      d.addEventListener("click", function () {
        items[i].scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
      });
      dotsWrap.appendChild(d);
    });
  }

  var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
  var ticking = false;
  root.addEventListener(
    "scroll",
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var idx = Math.round(root.scrollLeft / root.clientWidth);
        dots.forEach(function (d, i) {
          d.classList.toggle("is-active", i === idx);
        });
        ticking = false;
      });
    },
    { passive: true }
  );
})();

/* ---- ⑥ 出現アニメーション ----
   コーポレートサイトの fsj-reveal.js と同じ仕組みを移植（html/assets/js/fsj-reveal.js 参照）。
   IntersectionObserverで見えたときに1回だけ .is-revealed を付け、以後は監視をやめる。
   動きを減らす設定・IntersectionObserver非対応の環境では何もしない
   （＝CSS側の .lp-reveal-on も付かないため、最初から表示されたままになる）。

   対象はFVを含めない。FVはスクロール不要で最初から画面内にあるため、
   「隠してから出す」対象にする意味がなく、JSの読み込みが遅れた場合に
   一瞬でも消えるリスクだけが残る。 */
(function () {
  "use strict";

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (!("IntersectionObserver" in window)) return;

  document.documentElement.classList.add("lp-reveal-on");

  /* このファイルは2本のLPで共通。片方にしか無いクラスが混ざっていてよい
     （querySelectorAll は当たらなければ無視されるだけ）。
     ただし**存在しないクラスを残さない**こと。使われていないクラスが残っていると、
     「アニメーションを付けたつもりで、実際は対象が0件」に気づけなくなる。
     セクションを追加したらここにも足す。漏れると、そのセクションだけ
     最初から表示されたままになって前後とちぐはぐに見える。 */
  var SELECTOR = [
    /* 共通 */
    ".lp-sechead",
    ".lp2-sechead",

    /* LP①（member.html） */
    ".lp1-intro__photo",
    ".lp1-diagram__card",
    ".lp1-diagram__circle",
    ".lp1-perks__card",
    ".lp1-ecbenefit__col",
    ".lp1-ambassador__card",
    ".lp1-voice__card",
    ".lp1-step__card",
    ".lp1-campaign__head",
    ".lp1-campaign__item",

    /* LP②（kaitori.html） */
    ".lp2-values__item",
    ".lp2-step__card",
    ".lp2-examples__card",
    ".lp2-genre__item",
    ".lp2-voice__card",
    ".lp2-send__panel",
    ".lp2-doublecta__card"
  ].join(",");

  var targets = document.querySelectorAll(SELECTOR);
  if (!targets.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-revealed");
      io.unobserve(entry.target);
    });
  }, {
    /* 少し見えた時点で動かす。下端ぎりぎりだと動きに気づかれない */
    rootMargin: "0px 0px -18% 0px",
    threshold: 0.01
  });

  Array.prototype.forEach.call(targets, function (el) {
    el.classList.add("lp-reveal");

    /* 横並び・縦並びの兄弟は少しずつ遅らせる（順に現れる）。
       遅らせすぎると待たされている感じになるので上限を設ける */
    var parent = el.parentElement;
    if (parent) {
      var sibs = Array.prototype.filter.call(parent.children, function (c) {
        return c.classList && c.classList.contains("lp-reveal");
      });
      var i = sibs.indexOf(el);
      if (i > 0 && sibs.length > 1 && sibs.length <= 12) {
        el.style.setProperty("--lp-reveal-delay", Math.min(i, 4) * 150 + "ms");
      }
    }

    io.observe(el);
  });

  /* ---- 安全網 ----
     「JSで隠してから、見えたら出す」方式のため、何かの理由で通知が来ないと
     中身が永久に見えないままになりうる。setTimeoutは requestAnimationFrame と
     違いタブが非表示でも必ず動くので、2段構えで必ず出るようにする。 */

  function revealIfVisible() {
    Array.prototype.forEach.call(targets, function (el) {
      if (el.classList.contains("is-revealed")) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add("is-revealed");
        io.unobserve(el);
      }
    });
  }

  /* ① 読み込み直後に画面内にあるぶんを出す */
  setTimeout(revealIfVisible, 400);

  /* ② それでも隠れたままのものが残っていたら、最後は全部出す */
  setTimeout(function () {
    Array.prototype.forEach.call(targets, function (el) {
      if (!el.classList.contains("is-revealed")) {
        el.classList.add("is-revealed");
        io.unobserve(el);
      }
    });
  }, 4000);
})();
